import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthProvider.js";
import {
  buildPrepCenterInput,
  cadastroFromPrepCenter
} from "../lib/cadastro-form.js";
import type { PrepCenter } from "../types.js";
import { CadastroComSkus } from "./cadastro/CadastroComSkus.js";

/**
 * Cadastro › Prep Center (Design.md §8.3). Leitura ADMIN+OPERATOR (rota não
 * guardada); mutação ADMIN-only (backend prep-centers.ts) — botões de mutação
 * ocultos para Operador via `canMutate`. Campos Nome · Endereço · Telefone +
 * tabela de SKUs.
 */
export function PrepCenterPage(): ReactNode {
  const { api, me } = useAuth();
  const canMutate = me?.role === "ADMIN";

  return (
    <CadastroComSkus<PrepCenter>
      kind="prepCenter"
      title="Prep Center"
      subtitle="Cadastro"
      newLabel="Novo Prep Center"
      extraLabel="Telefone"
      extraColumnHeader="Telefone"
      extraInputType="tel"
      extraPlaceholder="+44 …"
      canMutate={canMutate}
      list={async () => (await api.listPrepCenters()).prepCenters}
      save={async (id, values) => {
        const input = buildPrepCenterInput(values);
        if (id === null) {
          await api.createPrepCenter(input);
        } else {
          await api.updatePrepCenter(id, input);
        }
      }}
      remove={async (id) => {
        await api.deletePrepCenter(id);
      }}
      getId={(p) => p.id}
      getName={(p) => p.name}
      getAddress={(p) => p.address}
      getExtraDisplay={(p) => <span className="mono">{p.phone}</span>}
      getSkuCount={(p) => p.skus.length}
      toForm={cadastroFromPrepCenter}
    />
  );
}
